<table>
  <tr>
    <td>
      <div class="header">
        <div class="header-title">User Profile</div>
        <p class="description">
          Review your account profile and update the email address associated
          with your access.
        </p>
      </div>

      <form [formGroup]="userForm" id="userForm">
        <div class="mt-5 user-uuid">
          <tr>
            <td>User Unique ID:</td>
            <td>
              <b>{{ user.uuid }}</b>
            </td>
          </tr>
        </div>
        <tr>
          <td>Full Name:</td>
          <td>
            <mat-form-field class="form-field">
              <input [disabled]="true" matInput placeholder="Edit Full Name" />
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>Email:</td>
          <td>
            <mat-form-field class="form-field">
              <input
                matInput
                placeholder="Edit Email Address"
                formControlName="emailInput"
                required
                [(ngModel)]="user.email"
                (change)="setEmailInputError()"
              />
              @if (userForm.get("emailInput").invalid) {
                <mat-error>{{ emailInputError }}</mat-error>
              }
            </mat-form-field>
          </td>
        </tr>
      </form>
      <button
        mat-raised-button
        color="primary"
        mat-button
        matTooltip="Apply Changes"
        [disabled]="!userForm.valid"
        (click)="applyChanges(user)"
      >
        Update Email
      </button>
    </td>
    <td style="padding-left: 100px">
      <div class="header">
        <div class="header-title">Change Password</div>
        <p class="description">
          Update your password to keep your account access secure.
        </p>
      </div>

      <form [formGroup]="userPasswordForm" id="userPasswordForm">
        <tr>
          <td>Current Password:</td>
          <td>
            <mat-form-field class="form-field">
              <input
                matInput
                placeholder="Validate Current Password"
                formControlName="currentPassword"
                required
                [(ngModel)]="pass.currentPassword"
                (change)="setCurrentPasswordError()"
                [type]="hidePassword ? 'password' : 'text'"
              />
              @if (currentPassword.invalid) {
                <mat-error>{{ currentPasswordError }}</mat-error>
              }
            </mat-form-field>
            <ng-icon
              [name]="hidePassword ? 'heroEye' : 'heroEyeOff'"
              class="pwd-hider icon-fw"
              (click)="hidePassword = !hidePassword"
              [attr.title]="hidePassword ? 'Show Password' : 'Hide Password'"
              [attr.aria-label]="
                hidePassword ? 'Show password' : 'Hide password'
              "
              aria-live="polite"
            ></ng-icon>
          </td>
        </tr>
        <tr>
          <td>New Password:</td>
          <td>
            <mat-form-field class="form-field">
              <input
                matInput
                placeholder="Set New Password"
                formControlName="newPassword"
                required
                [(ngModel)]="pass.newPassword"
                (change)="setNewPasswordError()"
                [type]="hideNewPassword ? 'password' : 'text'"
              />
              @if (newPassword.invalid) {
                <mat-error>{{ newPasswordError }}</mat-error>
              }
            </mat-form-field>
            <ng-icon
              [name]="hideNewPassword ? 'heroEye' : 'heroEyeOff'"
              class="pwd-hider icon-fw"
              (click)="hideNewPassword = !hideNewPassword"
              [attr.title]="hideNewPassword ? 'Show Password' : 'Hide Password'"
              [attr.aria-label]="
                hideNewPassword ? 'Show password' : 'Hide password'
              "
              aria-live="polite"
            ></ng-icon>
          </td>
        </tr>
        <tr>
          <td>Confirm New Password:</td>
          <td>
            <mat-form-field class="form-field">
              <input
                matInput
                placeholder="Confirm New Password"
                formControlName="confirmNewPassword"
                required
                [(ngModel)]="pass.confirmNewPassword"
                (change)="setConfirmNewPasswordError()"
                [type]="hideConfirmNewPassword ? 'password' : 'text'"
              />
              @if (confirmNewPassword.invalid) {
                <mat-error>{{ confirmNewPasswordError }}</mat-error>
              }
            </mat-form-field>
            <ng-icon
              [name]="hideConfirmNewPassword ? 'heroEye' : 'heroEyeOff'"
              class="pwd-hider icon-fw"
              (click)="hideConfirmNewPassword = !hideConfirmNewPassword"
              [attr.title]="
                hideConfirmNewPassword ? 'Show Password' : 'Hide Password'
              "
              [attr.aria-label]="
                hideConfirmNewPassword ? 'Show password' : 'Hide password'
              "
              aria-live="polite"
            ></ng-icon>
          </td>
        </tr>
      </form>
      <button
        mat-raised-button
        color="primary"
        mat-button
        matTooltip="Change Password"
        [disabled]="!userPasswordForm.valid"
        (click)="applyPasswordChanges()"
      >
        Update Password
      </button>
    </td>
  </tr>
</table>
